// packages/interface/src/components/index.js
import { default as default2 } from "./complementary-area/index.mjs";
import { default as default3 } from "./complementary-area-more-menu-item/index.mjs";
import { default as default4 } from "./fullscreen-mode/index.mjs";
import { default as default5 } from "./interface-skeleton/index.mjs";
import { default as default6 } from "./pinned-items/index.mjs";
import { default as default7 } from "./action-item/index.mjs";
export {
  default7 as ActionItem,
  default2 as ComplementaryArea,
  default3 as ComplementaryAreaMoreMenuItem,
  default4 as FullscreenMode,
  default5 as InterfaceSkeleton,
  default6 as PinnedItems
};
//# sourceMappingURL=index.mjs.map
